import styled from '@emotion/styled';
import { mq } from '~/lib';
import { Button } from '~/shared/components';
import { Container } from '~/shared/components/Container';
import Flex from '~/shared/components/Flex';
import Spinner from '~/shared/components/Spinner/Spinner';
import { breakpointsRaw } from '~/theme/breakpoints';

export const StyledCheckoutContainer = styled(Container)({
    maxWidth: 980,
    [mq(0, breakpointsRaw.sm)]: {
        paddingLeft: 0,
        paddingRight: 0,
    },
});

export const StyledLoader = styled(Flex)(() => ({
    textAlign: 'center',
    minHeight: '40vh',
}));

export const StyledSpinner = styled(Spinner)(({ theme }) => ({
    marginTop: theme.space['4'],
    marginBottom: theme.space['4'],
    width: 36,
    height: 36,
}));

export const StyledCheckoutWrapper = styled(Flex)(({ theme }) => ({
    width: '100%',
    gap: theme.space['5'],
}));

export const StyledCheckoutMain = styled.div({
    flex: 1,
    minWidth: 0,
});

export const StyledCheckoutAside = styled.aside(({ theme }) => ({
    flex: `0 0 ${theme.sizes.summaryBasket}`,
    maxWidth: theme.sizes.summaryBasket,

    // Aside components in Checkout are hidden on mobile.
    [mq(0, breakpointsRaw.md)]: {
        display: 'none',
    },
}));

export const StyledCheckoutMobileSubmit = styled(Button)(({ theme }) => ({
    width: '100%',
    marginTop: theme.space['3'],
    [mq(breakpointsRaw.md)]: {
        display: 'none',
    },
}));
